import Fuse from 'fuse.js';

export const extractResults = <T>(
  results: Fuse.FuseResult<T>[],
): T[] => results.map(result => result.item);
